export default __webpack_public_path__ + "static/media/4.e9e8bea8.jpeg";